export default __webpack_public_path__ + "768588ed0e789b42846f33579672edb6.png";